import { ProgressPayload, FileUploadedPayload } from './reducer';
import { ErrorTypes } from '../../services/upload/UploadService';

export enum TypeKeys {
    HANDLE_ERROR = 'fileUpload/HANDLE_ERROR',
    HANDLE_CANCELLED = 'fileUpload/HANDLE_CANCELLED',
    HANDLE_PROGRESS = 'fileUpload/HANDLE_PROGRESS',
    HANDLE_FILE_UPLOADED = 'fileUpload/HANDLE_FILE_UPLOADED',
    HANDLE_FILE_UPLOAD = 'fileUpload/HANDLE_FILE_UPLOAD',
    HANDLE_FILE_UPLOAD_COMPLETED = 'fileUpload/HANDLE_FILE_UPLOAD_COMPLETED',
    SET_CALLBACK_MESSAGES = 'fileUpload/SET_CALLBACK_MESSAGES',
    REMOVE_UPLOAD = 'fileUpload/REMOVE_UPLOAD',
}

export interface RemoveUploadAction {
    type: TypeKeys.REMOVE_UPLOAD;
}

export interface SetCallbackMessagesAction {
    type: TypeKeys.SET_CALLBACK_MESSAGES;
    data: any[];
}

export interface HandleErrorAction {
    type: TypeKeys.HANDLE_ERROR;
    error: ErrorTypes;
}

export interface HandleCancelledAction {
    type: TypeKeys.HANDLE_CANCELLED;
}

export interface HandleProgressAction {
    type: TypeKeys.HANDLE_PROGRESS;
    data: ProgressPayload;
}

export interface HandleFileUploadedAction {
    type: TypeKeys.HANDLE_FILE_UPLOADED;
    data: FileUploadedPayload;
}

export interface HandleFileUploadAction {
    type: TypeKeys.HANDLE_FILE_UPLOAD;
    selectedFile: File;
    uploadStartedAt: Date;
    ticket: string;
}

export interface HandleFileUploadCompleteAction {
    uploadedFileS3Name: string;
    type: TypeKeys.HANDLE_FILE_UPLOAD_COMPLETED;
}

export type ActionTypes = HandleErrorAction | HandleProgressAction | HandleCancelledAction
| HandleFileUploadAction | HandleFileUploadCompleteAction | HandleFileUploadedAction
| SetCallbackMessagesAction | RemoveUploadAction;

export const removeUpload = (): RemoveUploadAction => ({
    type: TypeKeys.REMOVE_UPLOAD,
});

export const setCallbackMessages = (data: any[]): SetCallbackMessagesAction => ({
    data,
    type: TypeKeys.SET_CALLBACK_MESSAGES,
});

export const handleError = (error: ErrorTypes): HandleErrorAction => ({
    error,
    type: TypeKeys.HANDLE_ERROR,
});

export const handleProgress = (data: any): HandleProgressAction => ({
    data,
    type: TypeKeys.HANDLE_PROGRESS,
});

export const handleCancelled = (): HandleCancelledAction => ({
    type: TypeKeys.HANDLE_CANCELLED,
});

export const handleFileUpload = (file: File, date: Date, ticket: string): HandleFileUploadAction => ({
    ticket,
    type: TypeKeys.HANDLE_FILE_UPLOAD,
    selectedFile: file,
    uploadStartedAt: date,
});

export const handleFileUploadComplete = (uploadedFileS3Name: string): HandleFileUploadCompleteAction => ({
    uploadedFileS3Name,
    type: TypeKeys.HANDLE_FILE_UPLOAD_COMPLETED,
});
